module.exports = ".editor-unavailable {\n  text-align: center;\n  color: #a6a6a6; }\n  .editor-unavailable .editor-unavailable-message {\n    margin-top: 0.5em;\n    font-size: 1.25em; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/editor/editor-unavailable/editor-unavailable.component.sass
// module id = ./src/app/editor/editor-unavailable/editor-unavailable.component.sass
// module chunks = main